module.exports = __webpack_public_path__ + "static/img/10.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/10.jpg
// module id = 8aBu
// module chunks = 36